<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card(min-height="90vh")
      v-card-title.pa-0
        div(style="width: 100%")
          v-row.pa-4(no-gutters align="center")
            v-col(cols="10" offset="1")
              div.text-xl.font-bold.neutral700--text.text-center {{ $t('new_appointment') }}
            v-col(cols="1" align="right")
              v-btn.ml-n3(text icon @click="closeDialog")
                v-icon(color="neutral700" :size="24") mdi-close
          v-divider
          div.pt-3(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
            div.main-container
              v-tabs(v-model="addApptTab" color="basic700" :height="40" grow slider-size="3")
                v-tab.text-sm.font-semibold.text-capitalize.px-0 
                  v-icon.mr-2(v-if="addApptTab > 0" color="success500" size="18") $yzi-check-circle
                  | 1. {{ $t('details') }}
                v-tab.text-sm.font-semibold.text-capitalize.px-0(:disabled="addApptTab < 1")
                  v-icon.mr-2(v-if="addApptTab > 1" color="success500" size="18") $yzi-check-circle
                  | 2. {{ $t('patient') }}
                v-tab.text-sm.font-semibold.text-capitalize.px-0(:disabled="addApptTab < 2") 3. {{ $t('payment') }}
                    
              div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

      v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'px-4 pb-4' : 'px-8 pb-8'")
        v-tabs-items(v-model="addApptTab" touchless)
          v-tab-item
            appointment-details.mt-6(ref="details")
              template(#title)
                div.text-md.font-semibold.neutral700--text {{ $t('fill_the_information_below') }}
          v-tab-item
            appointment-patient.mt-6(ref="patient")
              template(#title)
                div.text-md.font-semibold.neutral700--text {{ $t('type_patient_identification') }}
          v-tab-item
            appointment-payment.mt-6(ref="payment")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        y-button(label="Advanced appointment" underline button-class="px-0" @click="openAdvance()")
        v-spacer
        v-btn.button-md(v-if="addApptTab < 2" :loading="isLoading" color="neutral700" depressed :dark="!disabledNext" :disabled="disabledNext" @click="goNext") {{ $t('next') }}
        v-btn.button-md(v-else :loading="isLoading" color="neutral700" depressed :dark="!disabledConfirm" :disabled="disabledConfirm" @click="saveData") {{ $t('confirm_booking') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppointmentDetails from '@/components/clinic/appointment/AppointmentDetails.vue'
import AppointmentPatient from '@/components/clinic/appointment/AppointmentPatient.vue'
import AppointmentPayment from '@/components/clinic/appointment/AppointmentPayment.vue'

export default {
  name: 'AddAppointment',
  components: { AppointmentDetails, AppointmentPatient, AppointmentPayment },
  props: ['open'],
  data () {
    return {
      isLoading: false,
      addApptTab: 0,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      appointment: 'clinic/getTempAppointment',
      clinic: 'clinic/getClinic',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    disabledConfirm () {
      if (this.appointment && this.appointment.service) {
        if (this.appointment.service.booking_fee === 0) {
          return false
        } else if (this.appointment.payment && this.appointment.payment.record) {
          return false
        }
      }
      return true
    },
    disabledNext () {
      if (this.addApptTab === 1) {
        if (this.appointment) {
          if (!this.appointment.patient) {
            return true
          } else {
            if (this.defaultIC && !this.appointment.patient.ic) {
              return true
            }
            if (!this.defaultIC && !this.appointment.patient.phone) {
              return true
            }
          }
        }
      }
      return false
    },
    defaultIC () {
      if (this.clinic && this.clinic.customer_uid_type === 'ic') {
        return true
      }
      return false
    }
  },
  mounted () {
    this.$store.commit('hq/resetSelectedCompany')
  },
  methods: {
    ...mapActions(['showMessage']),
    goNext () {
      if (this.addApptTab === 0) {
        if (this.isHq && !this.hqSelectedCompany) {
          this.showMessage(['error', 'Please select a company'])
          return
        }
        if (!this.$refs.details.$refs.form.validate()) {
          return
        }
        this.addApptTab = 1
      } else if (this.addApptTab === 1) {
        if (!this.$refs.patient.$refs.form.validate()) {
          return
        }
        this.addApptTab = 2
      }
    },
    saveData () {
      if (!this.$refs.payment.$refs.form.validate()) {
        return
      }
      if (!this.appointment) {
        return
      }
      this.isLoading = true
      let data = {
        date: this.appointment.form.date,
        time: this.appointment.form.time,
        service: this.appointment.form.service,
        provider: this.appointment.form.provider
      }
      if (this.appointment.override) {
        data.ignore_rules = [ 'service_prep_time' ]
      }
      if (this.appointment.patient.id) {
        data.patient = this.appointment.patient.id
        if (this.appointment.form.remarks) {
          data.lead = { remarks: this.appointment.form.remarks }
        }
      } else {
        let patient = {
          name: this.appointment.patient.name,
          ic: this.appointment.patient.ic,
          phone: null
        }
        if (this.appointment.patient.email) {
          patient.email = this.appointment.patient.email
        }
        if (this.appointment.patient.phone && this.appointment.patient.phone.length > 3) {
          patient.phone = this.appointment.patient.phone
        }
        if (!this.checkEmptyAddress(this.appointment.address)) {
          patient.address = this.appointment.address
        }
        if (this.appointment.form.remarks) {
          patient.remarks = this.appointment.form.remarks
        }
        data.lead = patient
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      const endpoint = `/clinics/${companySlug}/appointments`
      this.$axios.post(endpoint, data)
        .then(resp => {
          this.updateActivityLog(endpoint, data, resp, 'POST')
          if (this.appointment.payment.amount > 0 && this.appointment.payment.record === 'pay-now') {
            let payment = {
              amount: this.appointment.payment.amount,
              gateway: 'direct',
              lead: resp.data.lead.id,
              paid: true,
              payment_method: this.appointment.payment.payment_method,
              internal_description: this.appointment.payment.internal_description
            }
            this.$axios.post(`/transactions`, payment)
              .then(() => {
                this.closeResetDialog()
              })
              .catch(() => {
                this.showMessage(['error', this.$t('error_message.unable_to_make_payment')])
                this.closeResetDialog()
              })
              .finally(() => {
                this.isLoading = false
              })
          } else {
            this.closeResetDialog()
            this.isLoading = false
          }
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
          this.isLoading = false
        })
    },
    closeResetDialog () {
      this.showDialog = false
      this.$store.commit('hq/resetSelectedCompany')
      this.$emit('reset')
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
    checkEmptyAddress (address) {
      if (!address) {
        return true
      }
      if (Object.keys(address).length === 0) {
        return true
      } else if (Object.values(address).every(val => !val)) {
        return true
      }
      return false
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'appointment',
        activity: 'Create new appointment',
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    openAdvance () {
      this.$emit('advance')
    }
  },
  destroyed () {
    this.$store.commit('clinic/resetTempAppointment')
    this.$store.commit('hq/resetSelectedCompany')
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:3px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>